import { PaymentType, ProductType, SchemaTypes } from '@allesauto/graphql';
import clsx from 'clsx';
import {
  WL_INTEGRATION_SLUG_AHG_ONLINE,
  WL_INTEGRATION_SLUG_AMZ_M_,
  WL_INTEGRATION_SLUG_AUREGO,
  WL_INTEGRATION_SLUG_AUTO_HEMPEL,
  WL_INTEGRATION_SLUG_AUTO_LEVY,
  WL_INTEGRATION_SLUG_AUTOHAUS_BRUCKER,
  WL_INTEGRATION_SLUG_AUTOHAUS_LADEMANN,
  WL_INTEGRATION_SLUG_AUTOHAUS_RUESCHKAMP,
  WL_INTEGRATION_SLUG_AUTOHAUS_SUK,
  WL_INTEGRATION_SLUG_BOB_AUTOMOBILE,
  WL_INTEGRATION_SLUG_ERTL_GRUPPE,
  WL_INTEGRATION_SLUG_HYUNDAI_AUTO_KUS,
  WL_INTEGRATION_SLUG_KAHLE,
  WL_INTEGRATION_SLUG_SCHNEIDER_GRUPPE,
  WL_INTEGRATION_SLUG_WALDHAUSEN,
  WL_INTEGRATION_WINTER_LAUSITZ,
} from 'web/src/features/whitelabel/util/getWhiteLabelIntegrationSlugs';

export const getPlusNotification: ({
  numOfNotification,
}: {
  numOfNotification: number;
}) => {
  plusNotification: 0 | boolean;
} = function ({ numOfNotification }) {
  const plusNotification = numOfNotification && numOfNotification > 99;
  return { plusNotification };
};

export function getCarConfigMonthlyPrice(
  financing: SchemaTypes.FinancingDetail[] | undefined
): number {
  if (!financing) return 0;

  return Number(
    financing.find(
      (fin) =>
        fin.type === PaymentType.LeasingRateRange ||
        fin.type === PaymentType.LoanRateRange
    )?.monthlyRate
  );
}

export const getNumberOfNotifications = function (
  cartItems: any[] | undefined
) {
  if (!cartItems) return 0;

  return cartItems.filter(
    (obj: any) =>
      obj.productType === ProductType.Vehicle ||
      obj.productType === ProductType.AccessoryStandAlone
  ).length;
};

function getBaseClassNames() {
  return {
    buttonContainerClass: 'flex pr-40px ',
    popoverButtonClass:
      'flex font-normal font-regular items-center  relative text-p1 text-purple80 transition-colors z-20 cursor-pointer h-full !border-0 !hover:border-b-0',
    popoverPanelClass:
      'absolute inset-x-0 top-[20px] z-50 bg-white w-[464px] flex -left-[425px]',
    notificationClass:
      '!leading-5 absolute wl-bg-highlight rounded-circle text-[12px] text-center text-white h-20px right-[-5px] w-20px lg:top-[-10px] top-[6px] md:top-[12px]',
    gridClass: clsx('bg-grey90 grid grid-cols-24 relative top-0'),
    linkClass:
      'duration-300 font-regular no-underline text-p1 !p-0 text-white transition-colors hover:text-grey50 overflow-visible text-ellipsis whitespace-nowrap block',
    containerClass: clsx(
      '!-mb-7px border-b-7px border-transparent flex h-[calc(100%-7px)] m-0 relative w-1/3 wl-border-highlight monochrome:border-grey70 hover:border-b-7px hover:border-green70'
    ),
    popoverClass:
      'flex items-center sm:justify-start p-0 h-full lg:pt-0 lg:ml-auto justify-center',
    buttonClass: 'flex items-center p-0',
    popoverTitleClass:
      'font-headline font-weight-bold text-headline4 text-grey100 text-left',
    customLinkClass: '',
    cartNotificationClass:
      'absolute !bg-white z-50 border-b-1px border-grey10 flex flex-col p-20px wrapper-flyout top-[20px] w-[464px] -left-[430px]',
  };
}

export function getWhiteLabelHeaderClassNames(
  whiteLabel: boolean | string | undefined
) {
  const ditGroup: Record<string, string> = {
    'ais-toyota-de': 'ais-toyota-de',
    'toyota-neff-de': 'toyota-neff-de',
    'dit-erfurt-de': 'dit-erfurt-de',
    'dit-muenchen-de': 'dit-muenchen-de',
    'dit-magdeburg-de': 'dit-magdeburg-de',
    'dit-halle-de': 'dit-halle-de',
    'dit-goettingen-de': 'dit-goettingen-de',
    'dit-frankengarage-de': 'dit-frankengarage-de',
  };

  const nowagGroup: Record<string, string> = {
    'braasch-gruppe-de': 'braasch-gruppe-de',
    'autohaus-schwarte-de': 'autohaus-schwarte-de',
  };

  const merchantOrigin = typeof whiteLabel === 'string' ? whiteLabel : '';
  const baseClassNames = getBaseClassNames();

  const priceClasses: Record<string, string> = {
    wrapperClass: 'pb-20px',
    mainPriceClass: '!text-p2',
    monthlyPriceTextClass: clsx(
      '!max-w-full !pt-0 !text-p2',
      whiteLabel ? 'font-headline' : '!font-headline'
    ),
    monthlyPriceClass: '!text-p2',
    monthlyPriceWrapperClass: '!flex-col !items-start',
  };

  switch (merchantOrigin) {
    case WL_INTEGRATION_SLUG_SCHNEIDER_GRUPPE: {
      return {
        className: {
          ...baseClassNames,
          popoverPanelClass: baseClassNames.popoverPanelClass.replace(
            'top-[20px]',
            'top-[24px]'
          ),
          notificationClass: baseClassNames.notificationClass.replace(
            'right-[-5px] w-20px lg:top-[-10px] top-[6px] md:top-[12px]',
            'wl-text-highlight border-1px rounded-circle w-20px left-[9px] top-[-7px]'
          ),
          cartNotificationClass: baseClassNames.cartNotificationClass.replace(
            'top-[20px]',
            'top-[24px]'
          ),
        },
        priceClasses,
      };
    }

    case WL_INTEGRATION_SLUG_AUTOHAUS_BRUCKER: {
      return {
        className: {
          ...baseClassNames,
          popoverPanelClass: baseClassNames.popoverPanelClass.replace(
            'top-[20px]',
            'top-[24px]'
          ),
          notificationClass: baseClassNames.notificationClass.replace(
            'right-[-5px] w-20px lg:top-[-10px] top-[6px] md:top-[12px]',
            'wl-text-highlight border-1px rounded-circle w-20px left-[9px] top-[-7px]'
          ),
          cartNotificationClass: baseClassNames.cartNotificationClass.replace(
            'top-[20px]',
            'top-[24px]'
          ),
        },
        priceClasses,
      };
    }

    case WL_INTEGRATION_SLUG_WALDHAUSEN: {
      return {
        className: {
          ...baseClassNames,
          popoverPanelClass: baseClassNames.popoverPanelClass.replace(
            'top-[20px]',
            'top-[47.9px]'
          ),
          notificationClass: baseClassNames.notificationClass.replace(
            'right-[-5px] w-20px lg:top-[-10px] top-[6px] md:top-[12px]',
            'right-[-10px] w-20px top-[2px]'
          ),
          cartNotificationClass: baseClassNames.cartNotificationClass.replace(
            'top-[20px]',
            'top-[47.9px]'
          ),
        },
        priceClasses,
      };
    }

    case WL_INTEGRATION_SLUG_HYUNDAI_AUTO_KUS: {
      return {
        className: {
          ...baseClassNames,
          linkClass: baseClassNames.linkClass.concat(' hover:!text-[#00AAD2]'),
          popoverPanelClass: baseClassNames.popoverPanelClass.replace(
            'top-[20px]',
            'top-[22px]'
          ),
          notificationClass: baseClassNames.notificationClass.replace(
            'right-[-5px] w-20px lg:top-[-10px] top-[6px] md:top-[12px]',
            'right-[-10px] w-20px top-[-10px]'
          ),
        },
        priceClasses,
      };
    }

    case WL_INTEGRATION_SLUG_AHG_ONLINE: {
      return {
        className: {
          ...baseClassNames,
          popoverClass: baseClassNames.popoverClass.replace(
            'sm:justify-start',
            'sm:relative sm:left-[50%] md:left-[0%]'
          ),
          notificationClass: baseClassNames.notificationClass.replace(
            'right-[-5px] w-20px lg:top-[-10px] top-[6px] md:top-[12px]',
            'right-[-10px] w-20px top-[-12px]'
          ),
        },
        priceClasses,
      };
    }

    case WL_INTEGRATION_SLUG_KAHLE: {
      return {
        className: {
          ...baseClassNames,
          notificationClass: baseClassNames.notificationClass.replace(
            'right-[-5px] w-20px lg:top-[-10px] top-[6px] md:top-[12px]',
            '-right-10px w-20px -top-10px border-1px'
          ),
        },
        priceClasses,
      };
    }

    case WL_INTEGRATION_SLUG_AUREGO: {
      return {
        className: {
          ...baseClassNames,
          popoverPanelClass: baseClassNames.popoverPanelClass.replace(
            'top-[20px]',
            'top-[42px]'
          ),
          notificationClass: baseClassNames.notificationClass.replace(
            'right-[-5px] w-20px lg:top-[-10px] top-[6px] md:top-[12px]',
            'notification-circle right-[2px] w-20px top-[2px]'
          ),
          cartNotificationClass: baseClassNames.cartNotificationClass.replace(
            'top-[20px]',
            'top-[42px]'
          ),
        },
        priceClasses,
      };
    }

    case WL_INTEGRATION_SLUG_BOB_AUTOMOBILE: {
      return {
        className: {
          ...baseClassNames,
          popoverPanelClass: baseClassNames.popoverPanelClass.replace(
            'top-[20px]',
            'top-[47.9px]'
          ),
          notificationClass: baseClassNames.notificationClass.replace(
            'right-[-5px] w-20px lg:top-[-10px] top-[6px] md:top-[12px]',
            'notification-circle -right-[10px] w-20px top-[4px]'
          ),
          cartNotificationClass: baseClassNames.cartNotificationClass.replace(
            'top-[20px]',
            'top-[47.9px]'
          ),
        },
        priceClasses,
      };
    }

    case WL_INTEGRATION_SLUG_AUTOHAUS_RUESCHKAMP: {
      return {
        className: {
          ...baseClassNames,
          notificationClass: baseClassNames.notificationClass.replace(
            'right-[-5px] w-20px lg:top-[-10px] top-[6px] md:top-[12px]',
            'w-20px left-[8px] top-[-9px] wl-text-color border-1px'
          ),
        },
        priceClasses,
      };
    }

    case WL_INTEGRATION_SLUG_ERTL_GRUPPE: {
      return {
        className: {
          ...baseClassNames,
          notificationClass: baseClassNames.notificationClass.replace(
            'right-[-5px] w-20px lg:top-[-10px] top-[6px] md:top-[12px]',
            'w-20px left-[10px] top-[-7px] border-1px'
          ),
        },
        priceClasses,
      };
    }

    case WL_INTEGRATION_WINTER_LAUSITZ: {
      return {
        className: {
          ...baseClassNames,
          notificationClass: baseClassNames.notificationClass.replace(
            'right-[-5px] w-20px lg:top-[-10px] top-[6px] md:top-[12px]',
            'w-20px left-[10px] top-[-7px] !text-white border-1px'
          ),
        },
        priceClasses,
      };
    }

    case WL_INTEGRATION_SLUG_AUTOHAUS_LADEMANN: {
      return {
        className: {
          ...baseClassNames,
          popoverButtonClass: baseClassNames.popoverButtonClass.concat(
            ' sm:relative sm:top-10px'
          ),
          notificationClass: baseClassNames.notificationClass.replace(
            'right-[-5px] w-20px lg:top-[-10px] top-[6px] md:top-[12px]',
            'w-20px -top-10px -right-10px rounded-circle'
          ),
        },
        priceClasses,
      };
    }

    case WL_INTEGRATION_SLUG_AUTO_LEVY: {
      return {
        className: {
          ...baseClassNames,
          popoverButtonClass: baseClassNames.popoverButtonClass.concat(
            ' md:relative top-15px lg:top-0'
          ),
          popoverPanelClass: baseClassNames.popoverPanelClass.replace(
            'top-[20px]',
            'top-[30px]'
          ),
          cartNotificationClass: baseClassNames.cartNotificationClass.replace(
            'top-[29px]',
            'top-[30px]'
          ),
          notificationClass: baseClassNames.notificationClass.replace(
            'right-[-5px] w-20px lg:top-[-10px] top-[6px] md:top-[12px]',
            'w-20px left-[10px] !text-white top-[-7px] border-1px'
          ),
        },
        priceClasses,
      };
    }

    case WL_INTEGRATION_SLUG_AUTOHAUS_SUK: {
      return {
        className: {
          ...baseClassNames,
          popoverPanelClass: baseClassNames.popoverPanelClass.replace(
            'top-[20px]',
            'top-[22px]'
          ),
          cartNotificationClass: baseClassNames.cartNotificationClass.replace(
            'top-[29px]',
            'top-[22px]'
          ),
          notificationClass: baseClassNames.notificationClass.replace(
            'right-[-5px] w-20px lg:top-[-10px] top-[6px] md:top-[12px]',
            'w-20px left-[10px] !text-white top-[-10px]'
          ),
        },
        priceClasses,
      };
    }

    case WL_INTEGRATION_SLUG_AUTO_HEMPEL: {
      return {
        className: {
          ...baseClassNames,
          notificationClass: baseClassNames.notificationClass.replace(
            'right-[-5px] w-20px lg:top-[-10px] top-[6px] md:top-[12px]',
            'w-20px left-[8px] top-[-7px] border-1px'
          ),
        },
        priceClasses,
      };
    }

    case WL_INTEGRATION_SLUG_AMZ_M_: {
      return {
        className: {
          ...baseClassNames,
          popoverButtonClass: baseClassNames.popoverButtonClass.concat(
            ' md:relative top-15px lg:top-0'
          ),
          popoverPanelClass: baseClassNames.popoverPanelClass.replace(
            'top-[20px]',
            'top-[30px]'
          ),
          cartNotificationClass: baseClassNames.cartNotificationClass.replace(
            'top-[29px]',
            'top-[30px]'
          ),
          notificationClass: baseClassNames.notificationClass.replace(
            'right-[-5px] w-20px lg:top-[-10px] top-[6px] md:top-[12px]',
            'w-20px left-[10px] !text-white top-[-7px] border-1px'
          ),
        },
        priceClasses,
      };
    }

    case nowagGroup[merchantOrigin]: {
      return {
        className: {
          ...baseClassNames,
          notificationClass: baseClassNames.notificationClass.replace(
            'right-[-5px] w-20px lg:top-[-10px] top-[6px] md:top-[12px]',
            'w-20px left-[8px] top-[-7px] border-1px'
          ),
        },
        priceClasses,
      };
    }

    case ditGroup[merchantOrigin]: {
      return {
        className: {
          ...baseClassNames,
          customLinkClass:
            '!h-[unset] !w-full !bg-white !rounded-none !border-none',
          popoverClass: baseClassNames.popoverClass.concat(
            ' lg:relative lg:top-[-8px] right-[4px]'
          ),
          popoverPanelClass: baseClassNames.popoverPanelClass.replace(
            'top-[20px]',
            'top-[31px]'
          ),
          notificationClass: baseClassNames.notificationClass.replace(
            'right-[-5px] w-20px lg:top-[-10px] top-[6px] md:top-[12px]',
            'right-[-3px] w-20px top-0'
          ),
          cartNotificationClass: baseClassNames.cartNotificationClass.replace(
            'top-[29px]',
            'top-[31px]'
          ),
        },
        priceClasses,
      };
    }

    default:
      return { className: baseClassNames, priceClasses };
  }
}
